/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * Panel.tsx — Panel (services/operator-web-app).
 */

import type { ReactNode } from 'react';

export interface PanelProps {
  title?: ReactNode;
  children: ReactNode;
  className?: string;
  /** Optional actions (e.g. buttons) in the header */
  actions?: ReactNode;
  /** Padding density */
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const paddingClasses = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
};

export function Panel({ title, children, className = '', actions, padding = 'md' }: PanelProps) {
  const contentPadding = paddingClasses[padding];
  const hasHeader = title != null || actions != null;

  return (
    <section
      className={`glass-panel ${className}`}
      aria-labelledby={title ? 'panel-title' : undefined}
    >
      {hasHeader && (
        <div className="flex items-center justify-between gap-2 border-b border-white/10 px-4 py-3">
          {title && (
            <h2
              id="panel-title"
              className="text-sm font-semibold"
              style={{ color: 'var(--text-primary)' }}
            >
              {title}
            </h2>
          )}
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className={contentPadding}>{children}</div>
    </section>
  );
}
